import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useCssClasses = makeStyles(() => {
  const theme = useTheme();
  return {
    root: {
      paddingBottom: '8px',
    },
    loginDescription: {
      flexDirection: 'column',
      '& span:first-of-type::after': {
        content: '""',
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        '& span:first-of-type::after': {
          content: '"\\a0"',
        },
      },
    },
  };
});
